module.exports = __webpack_public_path__ + "static/media/package2.be6d00fe.png";